import React from 'react';
import { SVGProps } from 'react';
import { clsx } from 'clsx';
import { IconProps, iconVariants } from '../icon';
import '../icon/icon.module.scss';
type Props = IconProps & Omit<SVGProps<SVGSVGElement>, keyof IconProps>;
const CheckCircle = React.forwardRef<SVGSVGElement, Props>(({ color, size, opacity = 1, className, ...props }, ref) => {
  const classes = clsx(
    iconVariants({
      color,
      size,
    }),
    className,
  );
  const style: React.CSSProperties = {
    '--opacity': opacity,
  };
  return React.cloneElement(
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" ref={ref} {...props}>
      <path
        fill="currentColor"
        d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8"
      />
      <path
        fill="currentColor"
        d="m15.97 8.47-5.47 5.47-2.47-2.47a.75.75 0 1 0-1.06 1.06l3 3a.747.747 0 0 0 1.06 0l6-6a.75.75 0 1 0-1.06-1.06"
      />
    </svg>,
    {
      role: 'presentation',
      focusable: false,
      className: classes,
      'aria-hidden': true,
      style,
      ...props,
    },
  );
});
CheckCircle.displayName = 'CheckCircle';
export default CheckCircle;
